import React from "react";
import { FiArrowRight } from "react-icons/fi";
import RegisterPage from "../../pages/Register/RegisterPage";

const Hero = () => {
  return (
    <div className="home-container">
      <div className="home-banner-container">
        <div className="home-bannerImage-container">
          
        </div>
        <div className="home-text-section">
          <h1 className="primary-heading">
          Get paid for your time
          </h1>
          <p className="primary-text">
          Play games, take surveys, and complete offers to earn cash and redeem your rewards for PayPal and gift cards.
          </p>
          <button className="secondary-button" onClick={() => { window.location.href = '/register'; }} type="button">
          Start Earning <FiArrowRight />{" "}
          </button>
        </div>
        <div className="home-image-section">
          <RegisterPage/>
        </div>
      </div>
    </div>
  );
};

export default Hero;